import { setupLayouts } from 'virtual:generated-layouts'
import { createRouter, createWebHistory } from 'vue-router'
import {isAuthenticated, loadUser, authenticateWithImpersonationToken, user} from "@/helpers/auth";

const routes = [
    {
        path: '/',
        name: 'home',
        component: () => import('@/views/Home.vue'),
        meta: {
            layout: 'blank',
            resource: 'Public'
        }
    },

    {
        path: '/error-404',
        name: 'error-404',
        component: () => import('@/views/Error404.vue'),
        meta: {
            layout: 'blank',
            resource: 'Public'
        }
    },
    {
        path: '/login',
        name: 'login',
        component: () => import('@/views/Login.vue'),
        meta: {
            layout: 'blank',
            resource: 'Public',
            redirectIfLoggedIn: true
        }
    },
    {
        path: '/register',
        name: 'register',
        component: () => import('@/views/Register.vue'),
        meta: {
            layout: 'blank',
            resource: 'Public',
            redirectIfLoggedIn: true
        }
    },
    {
        path: '/clinics/create',
        name: 'clinics-create',
        component: () => import('@/views/ClinicsCreate.vue'),
        meta: {
            layout: 'blank',
            resource: 'Public',
            redirectIfLoggedIn: true
        }
    },
    // {
    //   path: '/forgot-password',
    //   name: 'auth-forgot-password',
    //   component: () => import('@/views/ForgotPassword.vue'),
    //   meta: {
    //     layout: 'blank',
    //     resource: 'Public',
    //     redirectIfLoggedIn: true
    //   }
    // },

    {
        path: '/dashboard',
        name: 'dashboard',
        component: () => import('@/views/dashboard/Dashboard.vue'),
    },

    {
        path: '/appointments/list/:startDate?',
        name: 'appointments',
        component: () => import('@/views/appointments/list/Appointments.vue'),
    },

    {
        path: '/appointments/new',
        name: 'appointments-new',
        component: () => import('@/views/appointments/new/New.vue'),
    },

    {

        path: '/appointments/:id',
        name: 'appointments-view',
        component: () => import('@/views/appointments/view/View.vue'),
    },

    {
        path: '/patients',
        name: 'patients',
        component: () => import('@/views/patients/Patients.vue'),
    },

    {
        path: '/patients/:id',
        name: 'patients-view',
        component: () => import('@/views/patients/View.vue'),
    },

    {
        path: '/services',
        name: 'services',
        component: () => import('@/views/services/Services.vue'),
    },

    {
        path: '/settings',
        name: 'settings',
        component: () => import('@/views/settings/Settings.vue'),
    },

    {
        path: '/profile',
        name: 'profile',
        component: () => import('@/views/Profile.vue'),
    },

    {
        path: '/self-registrations',
        name: 'self-registrations',
        component: () => import('@/views/self-registrations/SelfRegistrations.vue'),
    },

    {
        path: '/invites',
        name: 'invites',
        component: () => import('@/views/Invites.vue'),
        meta: {
            layout: 'blank'
        }
    },

    {
        path: '/plans',
        name: 'plans',
        component: () => import('@/views/plans/Plans.vue'),
        meta: {
            layout: 'blank',
            resource: 'Public'
        }
    },

    {
        path: '/my-appointment',
        name: 'public-appointment',
        component: () => import('@/views/public/Appointment.vue'),
        meta: {
            layout: 'blank'
        }
    },

    {
        path: '/self/:clinicId',
        name: 'public-self-registration',
        component: () => import('@/views/public/SelfRegistration.vue'),
        meta: {
            layout: 'blank'
        }
    },

    {
        path: '/impersonate',
        name: 'impersonate',
        component: () => import('@/views/Impersonate.vue'),
        meta: {
            layout: 'blank',
            resource: 'Public'
        }
    },

    {
        path: '/:pathMatch(.*)*',
        redirect: 'error-404'
    }
];

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
      ...setupLayouts(routes)
  ]
})

router.beforeEach((to, _, next) => {
    loadUser();

    const loginRouteNames = [
        'login',
        'register'
    ];

    const publicRoutes = [
        'public-appointment',
        'public-self-registration',
        'plans',
        'home',
        'impersonate'
    ];

    if (isAuthenticated()) {
        const invites = user().invites;

        if (invites && invites.length > 0) {
            if (to.name != 'invites') {
                return next({name: 'invites'});
            }

            return next();
        }

        if (loginRouteNames.includes(to.name as string)) {
            return next({ name: 'dashboard' });
        }

        if (to.name != 'clinics-create' && !user().clinics?.length) {
            return next({ name: 'clinics-create' });
        }

        return next();
    }

    if (!loginRouteNames.includes(to.name as string) && !publicRoutes.includes(to.name as string)) {
        return next({ name: 'login' });
    }

    return next();
});

export default router;
